module.exports = __webpack_public_path__ + "img/file_upload.9e038ef6.png";